import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, Jsonp, URLSearchParams } from '@angular/http';
// import { User } from '../models/user';
import { AppConfig } from '../../app.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class LeadService {
    constructor(private http: Http, private config: AppConfig, private _jsonp: Jsonp) { }
    saveLead(lead: any) {
        return this.http.post(this.config.apiUrl + 'lead/create', lead, this.setHeaders()).map((response: Response) => response.json());
    }
    getAllLead(leadCurrentPage: number, maxSize: any, filter: any, isExport: any) {
        return this.http.post(this.config.apiUrl + 'lead/get-all?page=' + leadCurrentPage + '&limit=' + maxSize + '&isExport=' + isExport, filter, this.setHeaders()).map((response: Response) => response.json());
    }
    deleteLead(id: any) {
        return this.http.post(this.config.apiUrl + 'lead/delete', id, this.setHeaders()).map((response: Response) => response.json());
    }
    updateLead(lead: any) {
        return this.http.post(this.config.apiUrl + 'lead/update', lead, this.setHeaders()).map((response: Response) => response.json());
    }
    saveLeadActivity(req) {
        return this.http.post(this.config.apiUrl + 'leadActivity/create', req, this.setHeaders()).map((response: Response) => response.json());
    }
    findById(id: any) {
        return this.http.post(this.config.apiUrl + 'lead/findLeadById', { id: id }, this.setHeaders()).map((response: Response) => response.json());
    }
    findLeadActivityByLeadId(lead_id: any) {
        return this.http.get(this.config.apiUrl + 'leadActivity/get-by-lead-id/' + lead_id, this.setHeaders()).map((response: Response) => response.json());
    }
    getLeadNotificationDetail(reqData: any) {
        return this.http.post(this.config.apiUrl + 'notification/lead', reqData, this.setHeaders())
            .map((response: Response) => response.json());
    }
    bulkUploadLead(reqData: any) {
        return this.http.post(this.config.apiUrl + 'lead/bulk-upload', reqData, this.setHeaders()).map((response: Response) => response.json());
    }
    private setHeaders(params?: any) {
        // create authorization header with jwt token
        let token = localStorage.getItem('token');
        if (token) {
            // console.log('token >>>' + token);
            let headers = new Headers({ 'x-roamingse-token': token });
            if (params)
                return new RequestOptions({ headers: headers, search: params });
            else
                return new RequestOptions({ headers: headers });
        } else {
            return new RequestOptions({});
        }
    }
}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/lead.service.ts